import * as React from 'react'
import { Form } from 'react-final-form'

import { useCountryConfig } from '@ngb-frontend/shared/context'
import { applyMainServiceExclusion } from '@ngb-frontend/shared/rules'
import {
  MaintenanceAndRepair,
  type ServiceFormProps,
  type ServiceFormValues,
} from '@ngb-frontend/shared/types'
import {
  DRIVER_STEP_FORM_ID,
  ServicesField,
  StepFooterDisabledSync,
} from '@ngb-frontend/shared/ui'
import { camelize } from '@ngb-frontend/shared/utils'

import { ContactDirectlyBanner } from '../../ContactDirectlyBanner/ContactDirectlyBanner'

export const ServiceForm: React.FC<ServiceFormProps> = ({
  onSubmit,
  initialValues,
  variant,
  displayedServices,
  enabledServices,
}) => {
  const countryCode = useCountryConfig()?.countryCode
  const handleSubmit = React.useCallback(
    (values: ServiceFormValues) => {
      onSubmit?.({
        [camelize(variant) as keyof ServiceFormValues]: values.services || [],
      })
    },
    [onSubmit, variant],
  )

  const expandedContent = React.useMemo(
    () =>
      variant === MaintenanceAndRepair.Service
        ? { Repair: <ContactDirectlyBanner /> }
        : undefined,
    [variant],
  )

  return (
    <Form<ServiceFormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
    >
      {(formProps) => {
        // Live MOT ↔ main-service exclusion for Default-ruleset countries; a
        // no-op for the extra-services variant and non-Default countries
        const filteredServices = applyMainServiceExclusion(
          countryCode,
          enabledServices,
          formProps.values.services,
        )

        return (
          <form
            id={DRIVER_STEP_FORM_ID}
            onSubmit={formProps.handleSubmit}
            data-e2e-component="service-form"
          >
            <ServicesField
              services={displayedServices}
              variant={variant}
              enabledServices={filteredServices}
              hideLabel
              expandedContent={expandedContent}
            />
            <StepFooterDisabledSync disabled={formProps.invalid} />
          </form>
        )
      }}
    </Form>
  )
}
